export default "__VITE_ASSET__5w3XkhGc__"